// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"714efa04","25":"bd97b97f","787":"8cbee41d","864":"2eaea9cc"}[chunkId] + ".chunk.js";
};